// General Page Section
export const HOME_PAGE = '/';

// Listing Single Page Section
export const LISTING_POSTS_PAGE = '/listing';
export const SINGLE_POST_PAGE = '/post';

// Add Place
export const ADD_PLACE_PAGE = '/add';

// Other Pages
export const PRIVACY_PAGE = '/privacy';
export const TERMS_PAGE = '/terms';
export const ABOUT_PAGE = '/about';
export const BLOG_PAGE = '/blog';

// Blog posts
export const BLOG_POST_1 = '/blog/Roma-neighborhood-coffee-guide';
export const BLOG_POST_2 = '/blog/Tel-Aviv-coffee-guide';
